import { Link } from "react-router-dom";
import { ArrowUpRight, Snowflake, Wifi } from "lucide-react";
import { HOTEL, ROOMS, inr } from "@/constants/hotelData";
import Reveal from "@/components/Reveal";

export default function Rooms() {
  return (
    <section id="rooms" className="relative bg-[#0f241b] py-24 sm:py-28">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="flex flex-wrap items-end justify-between gap-6">
          <Reveal>
            <p className="mb-4 text-[10px] font-medium uppercase tracking-[0.34em] text-gold sm:text-xs">Stay</p>
            <h2 className="font-serif text-3xl tracking-tight text-cream sm:text-4xl lg:text-[2.75rem]">
              Rooms & Suites
            </h2>
          </Reveal>
          <Reveal delay={0.15}>
            <p className="font-mono text-sm text-goldlight/90" data-testid="rooms-price-note">
              All {HOTEL.totalRooms} rooms · {inr(HOTEL.ratePerNight)} per night · AC & Non-AC available
            </p>
          </Reveal>
        </div>

        <div className="mt-14 grid grid-cols-1 gap-8 md:grid-cols-3">
          {ROOMS.map((room, i) => (
            <Reveal key={room.name} delay={i * 0.12} className="h-full">
              <Link
                to="/book"
                data-testid={`room-card-${i}`}
                className="group flex h-full flex-col overflow-hidden rounded-2xl border border-gold/15 bg-ink/60 transition-all duration-500 hover:border-gold/50 hover:shadow-[0_24px_60px_rgba(0,0,0,0.5)]"
              >
                <div className="relative overflow-hidden">
                  <img
                    src={room.img}
                    alt={room.name}
                    className="aspect-[4/3] w-full object-cover transition-transform duration-700 group-hover:scale-105"
                  />
                  <div className="absolute right-4 top-4 rounded-full bg-ink/70 px-4 py-1.5 font-mono text-xs text-goldlight backdrop-blur">
                    {inr(HOTEL.ratePerNight)} / night
                  </div>
                </div>
                <div className="flex flex-1 flex-col p-6">
                  <h3 className="font-serif text-xl text-cream sm:text-2xl">{room.name}</h3>
                  <p className="mt-2 flex-1 text-sm font-light leading-relaxed text-stone-300">{room.desc}</p>
                  <div className="mt-5 flex items-center gap-4 text-xs text-cream/70">
                    <span className="flex items-center gap-1.5"><Snowflake className="h-3.5 w-3.5 text-gold" /> AC</span>
                    <span className="flex items-center gap-1.5"><Wifi className="h-3.5 w-3.5 text-gold" /> Wi-Fi</span>
                  </div>
                  <div className="mt-6 flex items-center justify-between border-t border-gold/15 pt-4">
                    <span className="text-[10px] uppercase tracking-[0.22em] text-cream/60">Reserve Now</span>
                    <span className="flex h-9 w-9 items-center justify-center rounded-full border border-gold/40 text-gold transition-all duration-300 group-hover:bg-gold group-hover:text-ink">
                      <ArrowUpRight className="h-4 w-4" />
                    </span>
                  </div>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
